import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.656 3.342a7 7 0 0 0-4.95 2.051l-3.538 3.538a1 1 0 0 0 1.414 1.414l3.538-3.538a5.002 5.002 0 0 1 7.073 7.073l-3.538 3.538a1 1 0 0 0 1.415 1.414l3.537-3.537a7.001 7.001 0 0 0-4.95-11.953"
    />
    <path
      fill="currentColor"
      d="M20.944 11.043a1 1 0 0 1 .001 1.414l-8.475 8.487a1 1 0 1 1-1.415-1.413l8.475-8.487a1 1 0 0 1 1.414-.002"
    />
    <path
      fill="currentColor"
      d="M10.345 13.168a1 1 0 0 1 0 1.414L6.807 18.12a5.001 5.001 0 1 0 7.073 7.073l3.538-3.538a1 1 0 0 1 1.414 1.415l-3.537 3.537a7 7 0 0 1-9.902 0 7 7 0 0 1 0-9.901l3.538-3.538a1 1 0 0 1 1.414 0"
    />
  </svg>
);
const SvgIconLinkSimple = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconLinkSimple);
export default Memo;
